module.exports = __webpack_public_path__ + "media/assets/login/icon-signup-2-653a6a6ab3215a6b011b4e980c0ec823.svg";